import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loggedIn : boolean = false;
  loggedInBehaviorSubject :BehaviorSubject<boolean>;
  // private loggedIn = new BehaviorSubject<boolean>(false); // {1}

  get isLoggedIn() {
    return this.loggedInBehaviorSubject.asObservable(); // {2}
  }

  constructor(private router: Router) { 
    this.loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    this.loggedInBehaviorSubject = new BehaviorSubject(this.loggedIn);
  }


  logIn(){
     localStorage.setItem('isLoggedIn', 'true'); 
      this.loggedInBehaviorSubject.next(true);
      // this.router.navigate(['welcome']);
      this.router.navigate(['']);
  }

  logout() {   
    localStorage.clear();                         // {4}
    this.loggedInBehaviorSubject.next(false);
    this.router.navigate(['']);
  }
}
